import * as React from 'react';
import { SVGProps } from 'react';

const IconFacebookSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10c.059 0 .117 0 .176-.004v-7.781h-2.149V11.71h2.149V9.867c0-2.137 1.304-3.3 3.21-3.3.915 0 1.7.066 1.927.097v2.234H16c-1.035 0-1.238.493-1.238 1.215v1.594h2.48l-.324 2.504h-2.156v7.402C18.942 20.414 22 16.566 22 12Z" />
  </svg>
);
export default IconFacebookSizeM;
